import { FeaturesQuery } from '@/graphql/graphql';
import { atom } from 'jotai';
import { LayerData } from './layers.atom';

export const selectedFeatureAtom = atom<
  | (FeaturesQuery['featuresByLayer'][number] & {
      isMoving?: boolean;
      isEditing?: boolean;
      isDraft?: boolean;
      onSave: (selectedFeature: any) => void;
    })
  | null
>(null);

export const layerPropertiesAtom = atom<(Partial<LayerData> & {}) | null>(null);
